<template>
<div id="app">
<div class="nav is-infoq">
  <div class="container">
    <div class="nav-item">
      <div class="logo">
        <a href="//www.infoq.com/cn" target="_blank"><img src="./assets/logo-infoq.svg" alt=""></a>
        <p>促进软件开发领域知识与创新与传播</p>
      </div>
    </div>
  </div>
</div>
<div class="banner is-tablet" :style="`background-image: url('${data.banner.pc}')`">
</div>
<div class="banner is-mobile" :style="`background-image: url('${data.banner.mobile}')`">
</div>
<div class="b-live c-box">
  <div class="c-title">{{data.schedule.title}}</div>
  <div class="container">
    <ul class="c-tabs-days" id="tabs">
      <li class="c-tab" :class="{active:dayid==='1'}" @click="changeDate('1', '1')">
        <h2>
          {{data.schedule['day1']['date'].MM}}月{{data.schedule['day1']['date'].dd}}日
        </h2>
        <h5>
          {{data.schedule['day1']['date'].duration}}
        </h5>
      </li>
      <li class="c-tab" :class="{active:dayid==='2'}" @click="changeDate('2', '1')">
        <h2>
          {{data.schedule['day2']['date'].MM}}月{{data.schedule['day2']['date'].dd}}日
        </h2>
        <h5>
          {{data.schedule['day2']['date'].duration}}
        </h5>
      </li>
      <li class="c-tab" :class="{active:dayid==='3'}" @click="changeDate('3', '1')">
        <h2>
          {{data.schedule['day3']['date'].MM}}月{{data.schedule['day3']['date'].dd}}日
        </h2>
        <h5>
          {{data.schedule['day3']['date'].duration}}
        </h5>
      </li>
    </ul>
    <div class="tabs-topic-wrapper">
      <ul class="c-tabs-topic">
        <li v-for="(topic, id) in data.schedule[`day${dayid}`]" v-if="topic.schtitle" class="c-tab" :class="{active:topicid===id}" @click="changeDate(dayid, id++)">
          <span>{{topic.schtitle}}</span>
        </li>
      </ul>
    </div>



    <div class="columns is-gapless">
      <div class="column is-video is-narrow">
        <div class="video" v-if="data.schedule.day1">
          <div v-if="curVideo.status === 'live'" id="livePlayer"></div>
          <div v-if="curVideo.status === 'mask'" class="mask" :style="{'background-image':`url('${curVideo.mask}')`}"></div>

          <iframe v-if="curVideo.status === 'playback'"
            :id="`cciframe_${curVideo.vid}`"
            :src="`https://p.bokecc.com/playhtml.bo?vid=${curVideo.vid}&siteid=1ECFA23CFAC24085&autoStart=false&playerid=6532F8AF7F72C091&playertype=1`"
            frameborder="0">
          </iframe>
          <!-- 检查flash -->
          <p v-if="!hasflash" class="warning-flash">
            <span>
              <p>您需要安装 Flash Player 后才能观看精彩直播～</p>
              <p>请您<a href="http://www.adobe.com/go/getflashplayer_cn">安装</a>后刷新本页面</p>
            </span>
          </p>
        </div>
      </div>
      <div class="column is-schedule">
        <div class="schedule">
          <h1>{{`英特尔®人工智能大会·${curVideo.schtitle}`}}</h1>
          <div class="columns is-mobile is-gapless">
            <div class="column is-narrow is-time is-head">
              时间
            </div>
            <div class="column is-content is-head">
              主题/演讲嘉宾
            </div>
          </div>
          <div class="sch">
            <div class="columns is-mobile is-gapless" v-for="sch in curVideo.schs" v-if="sch[0]">
              <div class="column is-narrow is-time is-datacell">
                {{sch[0]}}
              </div>
              <div class="column is-content is-datacell">
                <h1>{{sch[1]}}</h1>
                <h2 v-if="sch[2]">{{sch[2]}}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<div class="b-intro c-box">
  <div class="c-title">{{data.intro.title}}</div>
  <div class="container">
    <p>{{data.intro.content}}</p>
    <div class="more" v-if="!showmoreinfo">
      <a @click="showmoreinfo = true">查看全部>></a>
    </div>
    <template v-if="showmoreinfo">
      <div v-for="intro in data.intro.moreIntroduce">
        <h2>{{intro.title}}</h2>
        <p>{{intro.desc}}</p>
      </div>
    </template>
  </div>
</div>


<div class="b-members c-box">
  <div class="c-title">嘉宾介绍</div>
  <ul class="columns is-mobile childBox container">
    <li v-for="(item,index) in data.members" :key="index" class="column is-one-third-tablet is-half-mobile is-one-quarter-desktop">
      <!-- <a :href="item.urllink" target="_blank"> -->
      <a>
        <div class="img">
          <img :src="item.imgUrl">
        </div>
        <div class="content">
          <p class="name">{{item.name}}</p>
          <p class="company">{{item.company}}</p>
          <div class="profile">{{item.profile}}</div>
          <p class="brief">{{item.brief}}</p>
        </div>
      </a>
    </li>
  </ul>
</div>

<div class="b-intro2 c-box">
  <div class="c-title">{{data.intro2.title}}</div>
  <div class="container">
    <div class="columns is-multiline">
    <div v-for="data in data.intro2.list" class="column is-one-third-tablet">
      <div class="item">
        <div class="img"><img :src="data.img"></div>
        <h1>{{data.title}}</h1>
        <p>{{data.intro}}</p>
        <a class="more" :href="data.link" target="_blank">{{data.more}}</a>
      </div>
    </div>
    </div>
  </div>
</div>

<!-- <div class="b-teacher c-box">
  <div class="c-title">{{data.teacher.title}}</div>
  <div class="container">
    <div class="columns is-multiline display-tablet">
      <div class="column is-one-fifth" v-for="(teacher, index) in data.teacher.list">
        <div class="teacher">
          <div class="img">
            <img :src="teacher.img">
          </div>
          <h1>{{teacher.name}}</h1>
          <h2>{{teacher.title}}</h2>
          <p>{{teacher.intro}}</p>
        </div>
      </div>
    </div>
    <swiper style="position: relative; width: 100%;" class="display-mobile">
        <swiper-slide v-for="(teacher, index) in data.teacher.list" :key="index">
          <div class="teacher">
            <div class="img">
              <img :src="teacher.img">
            </div>
            <h1>{{teacher.name}}</h1>
            <h2>{{teacher.title}}</h2>
            <p>{{teacher.intro}}</p>
          </div>
        </swiper-slide>
    </swiper>
    <div class="ad">
      <img class="display-tablet" :src="data.teacher.adpc">
      <img class="display-mobile" :src="data.teacher.admobile">
    </div>
  </div>
</div> -->

<!-- <div class="b-image c-box">
  <div class="c-title">{{data.image.title}}</div>
  <div class="container">
    <p class="intro">{{data.image.intro}}</p>
    <div class="tile">
      <div class="tile">
        <img :src="data.image.imgs[0]">
      </div>
      <div class="tile is-vertical is-mobile">
        <div class="tile">
          <div class="tile">
            <img :src="data.image.imgs[1]">
          </div>
          <div class="tile">
            <img :src="data.image.imgs[2]">
          </div>
        </div>
        <div class="tile">
          <div class="tile">
            <img :src="data.image.imgs[3]">
          </div>
          <div class="tile">
            <img :src="data.image.imgs[4]">
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<com-fix qrcode="https://static.geekbang.org/infoq/5bea41da3e69a.png?imageView2/0/w/800"></com-fix>

<div class="footer">
  <div class="container">
    <span>© 2018 Geekbang Technology Ltd. All rights reserved.</span>
  </div>
</div>

<!-- edit -->
<edit :data="data" :debug="true" v-if="status === 'editing'"></edit>
</div>

</template>

<script>
// import axios from 'axios'
import data from './data'
import util from './util'
import edit from '@/components/edit'
import download from './vender/download'
import temp from './temp'
import comFix from '@/components/com-fix'

export default {
  data () {
    let status = window.location.search.slice(1)
    let hasflash = util.flashCheck()
    return {
      conid: '1',
      dayid: '1',
      topicid: '1',
      showmask: !data.living,
      showmoreinfo: false,
      status: status || 'prod',
      hasflash,
      dashboard: {
        editing: false,
        dragstartx: 0,
        dragstarty: 0,
        left: 0,
        top: 0,
        draging: false
      },
      data: window.GEEKBANG_DATA || data
    }
  },
  computed: {
    curVideo () {
      return this.data.schedule[`day${String(this.dayid)}`][`${String(this.topicid)}`]
    }
  },
  methods: {
    changeDate (dayid, topicid) {
      let DI = dayid || this.dayid
      let TI = topicid || this.topicid
      let l = window.location
      window.location.href = `${l.origin}${l.pathname}?dayid=${DI}&topicid=${TI}#tabs`
    },
    changeCon (id) {
      var l = window.location
      window.location.href = `${l.origin}${l.pathname}?id=${id}#tabs`
    },
    // initWxConfig: function () {
    //   const ua = window.navigator.userAgent
    //   if (!ua.match(/MicroMessenger/i)) return
    //   let url = window.location.href
    //   axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=geekbang`)
    //   .then(res => {
    //     if (res.data.code === 0) {
    //       if (!window.wx) return
    //       window.wx.config({
    //         debug: false,
    //         appId: res.data.data.appId,
    //         timestamp: res.data.data.timestamp,
    //         nonceStr: res.data.data.nonceStr,
    //         signature: res.data.data.signature,
    //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
    //       })
    //     }
    //   })
    //   window.wx.ready(function () {
    //     window.wx.onMenuShareTimeline({
    //       title: '英特尔人工智能大会',
    //       imgUrl: 'https://static.geekbang.org/infoq/5a0bd8641efb0.png',
    //       link: window.location.href,
    //       success: function () {},
    //       cancel: function () {}
    //     })
    //     window.wx.onMenuShareAppMessage({
    //       title: '英特尔人工智能大会',
    //       desc: '释放AI潜力',
    //       imgUrl: 'https://static.geekbang.org/infoq/5a0bd8641efb0.png',
    //       link: window.location.href,
    //       type: 'link',
    //       dataUrl: '',
    //       success: () => {},
    //       cancel: () => {}
    //     })
    //   })
    // },
    // editing
    gethtml () {
      if (!document.querySelector('#app-css')) return
      let css = document.querySelector('#app-css') && document.querySelector('#app-css').outerHTML
      let js = document.querySelector('#app-js') && document.querySelector('#app-js').outerHTML
      let data = JSON.stringify(this.data)
      download(temp.generateHtml(this.data.head, data, css, js), 'index.html', 'text/html')
    },
    getJson () {
      let data = JSON.stringify(this.data, null, '  ')
      download(data, 'data.json', 'text/json')
    },
    mousedown (e) {
      this.dashboard.draging = true
      var moveElemRect = e.target.getBoundingClientRect()
      this.dashboard.dragstartx = e.clientX - moveElemRect.left // 鼠标按下时和选中元素的坐标偏移:x坐标
      this.dashboard.dragstarty = e.clientY - moveElemRect.top // 鼠标按下时和选中元素的坐标偏移:y坐标
    },
    mousemove (e) {
      if (this.dashboard.draging) {
        this.dashboard.left = e.clientX - this.dashboard.dragstartx + 'px'
        this.dashboard.top = e.clientY - this.dashboard.dragstarty + 'px'
      }
    },
    mouseup () {
      this.dashboard.draging = false
    }
  },
  created () {
    // var conid = util.getCurUrlParameter('id')
    var dayid = util.getCurUrlParameter('dayid')
    var topicid = util.getCurUrlParameter('topicid')
    this.dayid = dayid ? String(dayid) : '1'
    this.topicid = topicid ? String(topicid) : '1'
    // this.initWxConfig()

    if (window.location.protocol.indexOf('file') > -1 ||
        window.location.search.indexOf('status=editing') > -1) {
      this.status = 'editing'
    }
  },
  mounted () {
    // 检测是否开启 flash
    // 判断 直播状态
    // 直播前：显示cover;直播中，初始化播放器；
    // var flashTip = document.querySelector('#flashTip')
    // flashTip.style.display = 'none'
    // setTimeout(() => {
    //   flashTip.style.display = 'block'
    // }, 1000)
    // dayid & topicid => 直播状态
    if (this.curVideo.status === 'live') {
      window.DWLive.init({
        userid: '1ECFA23CFAC24085',
        roomid: String(this.curVideo.roomid)
      })
      // if (data.schedule[this.conid].playbackid) {
      //   if (window.$ && window.$.DW) {
      //     window.$.DW.config({
      //       userId: '1ECFA23CFAC24085',
      //       roomId: data.schedule[this.conid].liveid,
      //       recordId: data.schedule[this.conid].playbackid,
      //       viewername: '',
      //       viewertoken: ''
      //     })
      //   }
      // } else {
      //   if (window.DWLive) {
      //     window.DWLive.init({
      //       userid: '1ECFA23CFAC24085',
      //       roomid: String(data.schedule[this.conid].liveid),
      //       viewername: '',
      //       viewertoken: '',
      //       viewercustomua: ''
      //     })
      //   }
      // }
    }
  },
  components: {
    edit,
    comFix
  }
}
</script>

<style lang="sass">
.util-edit-wrap
  position: fixed
  bottom: 20px
  left: 20px
  display: flex
.util-btn
  margin-right: 20px
  display: flex
  color: #fff
  font-size: 16px
  border-radius: 5px
  padding: 10px 20px
  cursor: pointer
  z-index: 1000
  transition: opacity 0.3s
  user-select: none
  &:hover
    opacity: 0.8
.util-btn.is-edit
  background-color: blue
.util-btn.is-download
  background-color: green
.util-dashboard
  display: block
  position: fixed
  top: 5%
  left: 2%
  width: 50%
  height: 80%
  background: white
  opacity: 0.8
  box-shadow: 0 0 50px 0 #ccc
  overflow: auto
</style>



// WEBPACK FOOTER //
// src/App.vue